import React from 'react';

import { Card } from '@/components/ui/card';

export default function CheckoutNotesRecapCard({
  notesRecapIntro,
  scheduledDisplay,
  orderNotesTrim,
}) {
  if (!notesRecapIntro) return null;

  return (
    <Card className="p-5 sm:p-6 border-primary/25 bg-primary/5">
      <p className="font-medium mb-3">{notesRecapIntro}</p>
      <ul className="text-sm space-y-2 text-muted-foreground list-none pl-0">
        {scheduledDisplay ? (
          <li>
            <span className="text-foreground font-medium">Hora solicitada:</span> {scheduledDisplay}
          </li>
        ) : null}
        {orderNotesTrim ? (
          <li>
            <span className="text-foreground font-medium">Indicaciones:</span>{' '}
            {orderNotesTrim.length > 280 ? `${orderNotesTrim.slice(0, 280)}…` : orderNotesTrim}
          </li>
        ) : null}
      </ul>
    </Card>
  );
}
